import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Helmet } from 'react-helmet-async';
import { ParagraphRegular } from './Paragraph';
import { ReactComponent as HAALogo } from '../assets/images/svg/logo-colored.svg';
import { ReactComponent as GSLogo } from '../assets/images/svg/GoldSilverLogo.svg';
import { ReactComponent as ContosoLogo } from '../assets/images/svg/ContosoLogo.svg';
import { ReactComponent as LPMLogo } from '../assets/images/Logo/LegacyPM.svg';
import { ReactComponent as GBIDLogo } from '../assets/images/Logo/GBIDirectLogo.svg';
import Paragraph from './Paragraph/Paragraph';
import { variables } from '../assets/styles/variables';

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  @media only screen and (max-width: 500px) {
    padding: 20px;
  }
`;

const HAALogoStyled = styled(HAALogo)`
  width: 144px;
  height: 28px;
`;

const GSLogoStyled = styled(GSLogo)`
  width: 144px;
  height: 28px;
`;

const ContosoLogoStyled = styled(ContosoLogo)`
  width: 144px;
  height: 28px;
`;

const LPMLogoStyled = styled(LPMLogo)`
  width: 144px;
  height: 28px;
`;

const GBIDLogoStyled = styled(GBIDLogo)`
  width: 144px;
  height: 28px;
`;

const TextContainer = styled.div`
  margin-top: 10px;
  max-width: ${variables.params.welcomeContentWidth};
  text-align: center;
`;

const quoteLogos = {
  HAA: HAALogoStyled,
  GS: GSLogoStyled,
  CONTOSO: ContosoLogoStyled,
  LPM: LPMLogoStyled,
  GBID: GBIDLogoStyled,
};

const LoadingMessage = ({ BrokerCode }) => {
  const { t } = useTranslation();
  const LogoStyled = quoteLogos[`${BrokerCode}`];

  return (
    <InnerContainer>
      <Helmet>
        <title>{t('loading')}</title>
      </Helmet>
      <LogoStyled />

      <TextContainer>
        <ParagraphRegular>{t('loginFluent.theQuote')}</ParagraphRegular>
      </TextContainer>
      <TextContainer>
        <Paragraph>{t('loginFluent.theQuoteAuthor')}</Paragraph>
      </TextContainer>
    </InnerContainer>
  );
};

LoadingMessage.propTypes = {
  BrokerCode: PropTypes.string,
};

export default LoadingMessage;
